import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {StoreModule} from '@ngrx/store';
import dayjs from 'dayjs';
import localData from 'dayjs/plugin/localeData';
import {NgxSpinnerModule} from 'ngx-spinner';
import {ToastrModule} from 'ngx-toastr';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {AuthGuard} from './auth/auth.guard';
import {AuthModule} from './auth/auth.module';
import {AuthService} from './auth/auth.service';
import {TokenInterceptor} from './auth/httpconfig.interceptor';
import {AlertService} from './main/alert.service';
import {DataSharingService} from './main/data-sharing.service';
import {MainModule} from './main/main.module';
import {ErrorInterceptor} from './utility/error.interceptor';
import {contentStateReducer} from './utility/reducers/content.reducer';
import {reducer} from './utility/reducers/insert-program.reducer';
import {objectReducer} from './utility/reducers/object.reducer';
import {postersWithoutCatchupReducer} from './utility/reducers/poster-without-catchup.reducer';
import {queryParamReducer} from './utility/reducers/queryparams.reducer';
import {refreshStateReducer} from './utility/reducers/refresh-state.reducer';
import {SuccessInterceptor} from './utility/success.interceptor';
import { registerLocaleData } from '@angular/common';
import { MessageService } from 'primeng/api';
import {QuickLinkPublicComponent} from './quick-link-public/quick-link-public.component';

import localeTr from '@angular/common/locales/tr';
registerLocaleData(localeTr);

dayjs.extend(localData);
dayjs.weekdays();
dayjs.localeData().weekdays();
dayjs.locale('tr', {
  weekStart: 1,
});

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    MainModule,
    AuthModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
      closeButton: true,
      progressBar: true,
      extendedTimeOut: 1000,
      timeOut: 5000,
      iconClasses: {
        error: 'toast-error',
        info: 'toast-info',
        success: 'toast-success',
        warning: 'toast-warning',
      },
    }),
    NgbPaginationModule,
    StoreModule.forRoot({
      insertProgram: reducer,
      posters: postersWithoutCatchupReducer,
      status: refreshStateReducer,
      content: contentStateReducer,
      queryParams: queryParamReducer,
      object: objectReducer,
    }),
  ],

  declarations: [AppComponent, QuickLinkPublicComponent],

  providers: [
    AuthService,
    AuthGuard,
    AlertService,
    DataSharingService,
    MessageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SuccessInterceptor,
      multi: true,
    },
    // {provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: HttpErrorInterceptor,
    //   multi: true,
    // },
    {provide: LOCALE_ID, useValue: 'tr-TR'},
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
